import documentService from "@/features/dashboard/api/services/document-service.ts";
import { useMutation } from "@tanstack/react-query";

export const useDocumentConfigMutation = (options?: { enabled: boolean }) => {
	return useMutation({
		mutationKey: ["document_token"],
		mutationFn: documentService.getToken,
		...options,
	});
};
